document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth > 768) {
        const butterfly = document.createElement('div');
        butterfly.className = 'butterfly-cursor';

        const img = document.createElement('img');
        img.src = 'https://cdn.shopify.com/s/files/1/0970/0691/1620/files/love.svg?v=1761482640';
        img.style.width = '30px';
        img.style.height = '30px';
        img.style.pointerEvents = 'none';
        img.style.transition = 'filter 0.3s ease';

        butterfly.appendChild(img);
        document.body.appendChild(butterfly);

        butterfly.style.display = 'none';

        // دالة للتحقق من لون الخلفية
        function checkBackgroundColor(element) {
            const bgColor = window.getComputedStyle(element).backgroundColor;
            // تحويل rgb لـ hex للمقارنة
            return bgColor;
        }

        document.addEventListener('mousemove', function(e) {
            butterfly.style.display = 'block';
            butterfly.style.left = e.clientX + 'px';
            butterfly.style.top = e.clientY + 'px';

            // الحصول على العنصر تحت الماوس
            const elementBelow = document.elementFromPoint(e.clientX, e.clientY);

            if (elementBelow) {
                const bgColor = window.getComputedStyle(elementBelow).backgroundColor;

                // تحويل اللون للتحقق منه
                const rgb = bgColor.match(/\d+/g);
                if (rgb) {
                    const hex = '#' + ((1 << 24) + (parseInt(rgb[0]) << 16) + (parseInt(rgb[1]) << 8) + parseInt(rgb[2])).toString(16).slice(1).toUpperCase();

                    // التحقق من الألوان المحددة
                    if (hex === '#E195AB' || hex === '#FF66C4') {
                        img.style.filter = 'brightness(0) invert(1)'; // تحويل للأبيض
                    } else {
                        img.style.filter = 'none'; // اللون الأصلي
                    }
                }
            }
        });

        document.addEventListener('mouseleave', function() {
            butterfly.style.display = 'none';
        });

        document.addEventListener('mouseenter', function() {
            butterfly.style.display = 'block';
        });
    }
});